import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Facebook from './Facebook';
import ClientProvider from './client';
export default createDemo(import.meta.url, Facebook, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/skeleton/demos/facebook/Facebook.tsx",
    "fileName": "Facebook.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Card from '@mui/material/Card';\nimport CardHeader from '@mui/material/CardHeader';\nimport CardContent from '@mui/material/CardContent';\nimport CardMedia from '@mui/material/CardMedia';\nimport Avatar from '@mui/material/Avatar';\nimport Typography from '@mui/material/Typography';\nimport IconButton from '@mui/material/IconButton';\nimport MoreVertIcon from '@mui/icons-material/MoreVert';\nimport Skeleton from '@mui/material/Skeleton';\n\ninterface MediaProps {\n  loading?: boolean;\n}\n\nfunction Media(props: MediaProps) {\n  const { loading = false } = props;\n\n  return (\n    <Card sx={{ maxWidth: 345, m: 2 }}>\n      <CardHeader\n        avatar={\n          loading ? (\n            <Skeleton animation=\"wave\" variant=\"circular\" width={40} height={40} />\n          ) : (\n            <Avatar\n              alt=\"Ted talk\"\n              src=\"https://pbs.twimg.com/profile_images/877631054525472768/Xp5FAPD5_reasonably_small.jpg\"\n            />\n          )\n        }\n        action={\n          loading ? null : (\n            <IconButton aria-label=\"settings\">\n              <MoreVertIcon />\n            </IconButton>\n          )\n        }\n        title={\n          loading ? (\n            <Skeleton\n              animation=\"wave\"\n              height={10}\n              width=\"80%\"\n              style={{ marginBottom: 6 }}\n            />\n          ) : (\n            'Ted'\n          )\n        }\n        subheader={\n          loading ? (\n            <Skeleton animation=\"wave\" height={10} width=\"40%\" />\n          ) : (\n            '5 hours ago'\n          )\n        }\n      />\n      {loading ? (\n        <Skeleton sx={{ height: 190 }} animation=\"wave\" variant=\"rectangular\" />\n      ) : (\n        <CardMedia\n          component=\"img\"\n          height=\"140\"\n          image=\"https://pi.tedcdn.com/r/talkstar-photos.s3.amazonaws.com/uploads/72bda89f-9bbf-4685-910a-2f151c4f3a8a/NicolaSturgeon_2019T-embed.jpg?w=512\"\n          alt=\"Nicola Sturgeon on a TED talk stage\"\n        />\n      )}\n      <CardContent>\n        {loading ? (\n          <React.Fragment>\n            <Skeleton animation=\"wave\" height={10} style={{ marginBottom: 6 }} />\n            <Skeleton animation=\"wave\" height={10} width=\"80%\" />\n          </React.Fragment>\n        ) : (\n          <Typography variant=\"body2\" component=\"p\" sx={{ color: 'text.secondary' }}>\n            {\n              \"Why First Minister of Scotland Nicola Sturgeon thinks GDP is the wrong measure of a country's success:\"\n            }\n          </Typography>\n        )}\n      </CardContent>\n    </Card>\n  );\n}\n\nexport default function Facebook() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Media loading />\n      <Media />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 94,
        "focusedLines": 2,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Card from '@mui/material/Card';\nimport CardHeader from '@mui/material/CardHeader';\nimport CardContent from '@mui/material/CardContent';\nimport CardMedia from '@mui/material/CardMedia';\nimport Avatar from '@mui/material/Avatar';\nimport Typography from '@mui/material/Typography';\nimport IconButton from '@mui/material/IconButton';\nimport MoreVertIcon from '@mui/icons-material/MoreVert';\nimport Skeleton from '@mui/material/Skeleton';\n\ninterface MediaProps {\n  loading?: boolean;\n}\n\nfunction Media(props: MediaProps) {\n  const { loading = false } = props;\n\n  return (\n    <Card sx={{ maxWidth: 345, m: 2 }}>\n      <CardHeader\n        avatar={\n          loading ? (\n            <Skeleton animation=\"wave\" variant=\"circular\" width={40} height={40} />\n          ) : (\n            <Avatar\n              alt=\"Ted talk\"\n              src=\"https://pbs.twimg.com/profile_images/877631054525472768/Xp5FAPD5_reasonably_small.jpg\"\n            />\n          )\n        }\n        action={\n          loading ? null : (\n            <IconButton aria-label=\"settings\">\n              <MoreVertIcon />\n            </IconButton>\n          )\n        }\n        title={\n          loading ? (\n            <Skeleton\n              animation=\"wave\"\n              height={10}\n              width=\"80%\"\n              style={{ marginBottom: 6 }}\n            />\n          ) : (\n            'Ted'\n          )\n        }\n        subheader={\n          loading ? (\n            <Skeleton animation=\"wave\" height={10} width=\"40%\" />\n          ) : (\n            '5 hours ago'\n          )\n        }\n      />\n      {loading ? (\n        <Skeleton sx={{ height: 190 }} animation=\"wave\" variant=\"rectangular\" />\n      ) : (\n        <CardMedia\n          component=\"img\"\n          height=\"140\"\n          image=\"https://pi.tedcdn.com/r/talkstar-photos.s3.amazonaws.com/uploads/72bda89f-9bbf-4685-910a-2f151c4f3a8a/NicolaSturgeon_2019T-embed.jpg?w=512\"\n          alt=\"Nicola Sturgeon on a TED talk stage\"\n        />\n      )}\n      <CardContent>\n        {loading ? (\n          <React.Fragment>\n            <Skeleton animation=\"wave\" height={10} style={{ marginBottom: 6 }} />\n            <Skeleton animation=\"wave\" height={10} width=\"80%\" />\n          </React.Fragment>\n        ) : (\n          <Typography variant=\"body2\" component=\"p\" sx={{ color: 'text.secondary' }}>\n            {\n              \"Why First Minister of Scotland Nicola Sturgeon thinks GDP is the wrong measure of a country's success:\"\n            }\n          </Typography>\n        )}\n      </CardContent>\n    </Card>\n  );\n}\n\nexport default function Facebook() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Media loading />\n      <Media />\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 90
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Media"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "loading"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 91
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Media"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 94,
    "focusedLines": 2,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Card",
      "@mui/material/CardHeader",
      "@mui/material/CardContent",
      "@mui/material/CardMedia",
      "@mui/material/Avatar",
      "@mui/material/Typography",
      "@mui/material/IconButton",
      "@mui/icons-material/MoreVert",
      "@mui/material/Skeleton"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
